import { render, staticRenderFns } from "./AddDialog.vue?vue&type=template&id=7d20c4bc&scoped=true&"
import script from "./AddDialog.vue?vue&type=script&lang=js&"
export * from "./AddDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d20c4bc",
  null
  
)

export default component.exports